// material
import {Stack} from '@mui/material';
// components
import {toast} from 'react-toastify';
import SubmitButton from 'src/components/buttons/SubmitButton';
import PasswordField from 'src/components/inputs/PasswordField';
import FormikWrapper from 'src/components/wrappers/FormikWrapper';
import {request} from 'src/utils/AdminApi';
import * as yup from 'yup';

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

const schema = yup.object({
	password: yup
		.string()
		// .min(8, 'ادخل كلمة السر اكثر من 8 حروف')
		.required(' يرجى ادخال  كلمة السر الجديدة '),
	confirmPassword: yup
		.string()
		.required('يرجى تأكيد كلمة السر الجديدة ')
		.test('confirm-password-test', 'كلمة السر غير متطابقة', function (value) {
			return value === this.parent.password;
		}),
});

export default function ResetPassword({user, onSuccess}) {
	const handleSubmit = async (values) => {
		const {password} = values;
		try {
			request('/user/reset-password', 'PUT', {password, uid: user.id});

			toast.success('تم التحديث بنجاح', {
				position: 'top-center',
			});

			if (onSuccess) onSuccess();
		} catch (error) {
			if (error.response.status === 400) toast.error('كلمة المرور الحالية غير صحيحة');
			else toast.error('حدث خطا غير متوقع');
		}
	};

	return (
		<FormikWrapper
			hideSubmitButton
			values={{
				password: '',
				confirmPassword: '',
			}}
			schema={schema}
			handleSubmit={handleSubmit}
		>
			{({isSubmitting, getInputProps}) => (
				<Stack spacing={4}>
					<PasswordField
						type="text"
						label={'كلمة المرور الجديدة'}
						fullWidth
						{...getInputProps('password')}
					/>

					<PasswordField
						type="text"
						label={'تأكيد كلمة المرور '}
						fullWidth
						{...getInputProps('confirmPassword')}
					/>

					<SubmitButton isSubmitting={isSubmitting}>تحديث </SubmitButton>
				</Stack>
			)}
		</FormikWrapper>
	);
}
